export enum AddressIdentifier {
    BILLING_ADDRESS = 'billing-address',
    DELIVERY_ADDRESS = 'delivery-address',
    PICKUP_ADDRESS = 'pickup-address',
    DELIVERY_INFO = 'delivery-info',
}
